import React, { useEffect, useState } from "react";
import * as jnb from "react-bootstrap";
import {
  FaChartLine,
  FaChartPie,
  FaPlusSquare,
  FaTag,
  FaObjectGroup,
  FaTimesCircle,
  FaLock,
  FaCheck,
} from "react-icons/fa";
import { CommonAxiosGet } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
// import NewClosureAdditional from "./NewClosureAdditional";
// import ConversionProgram from "./ConversionProgram";
import AdmissionAndResultAnalysis from "./AdmissionAndResultAnalysis";
import NewAdditonalSection from "./NewAdditonalSection";
import NewConversionProgramForDg from "./newConversionProgramForDg";
import Swal from "sweetalert2";
import FinalAmountForIntakeTabs from "./FinalAmountForIntakeTabs";
import NewCourse from "./NewProgram";


export default function IntakeTabs({ serviceTitle }) {
  console.log("serviceTitle", serviceTitle)
  // ===================== LOCK STATE =====================
  const [firstTabSubmitted, setFirstTabSubmitted] = useState(false);
  const [activeTab, setActiveTab] = useState("admission");
  const handleFirstTabSubmit = () => {
    setFirstTabSubmitted(true);
  };
  const college=sessionStorage.getItem("user_id")
  //==========For Amount Tab======
  const [hasNewProgramData, setHasNewProgramData] = useState(false);
  const checkNewProgramData = () => {
    const url = `${config.url.FAC_URL}getInputDetails/new/${college}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.scode === "01" && res.data.new?.length > 0) {
          setHasNewProgramData(true);
        } else {
          setHasNewProgramData(false);
        }
      });
  };
  // ===================== TAB SWITCH LOGIC =====================
  const handleToggle = (id) => {
    if (id === "admission") {
      setActiveTab(id);
      return;
    }
    if (!firstTabSubmitted) {
      Swal.fire({
        icon: "warning",
        title: "Access Blocked!",
        text: "Please complete and submit the 'Admission Details & Result Analysis' section first before using other tabs.",
        confirmButtonText: "OK",
      });
      return;
    }
    setActiveTab(id);
  };
  // ===================== TAB CONFIGURATION =====================
  const cardData = [
    {
      id: "admission",
      title: "Admission Details",
      icon: <FaObjectGroup />,
      color: "#6c757d",
    },
    {
      id: "new",
      title: "New Program",
      icon: <FaPlusSquare />,
      color: "#4caf50",
    },
    {
      id: "conversion",
      title: "Conversion of program",
      icon: <FaChartPie />,
      color: "#f44336",
    },
    {
      id: "closure",
      title: "Closure/Reduction",
      icon: <FaTimesCircle />,
      color: "#2196f3",
    },
    {
      id: "additional",
      title: "New Additional Section",
      icon: <FaTag />,
      color: "#ff9800",
    },
    {
      id: "Final",
      title: "Final Confirmation",
      icon: <FaCheck />,
      color: "#43693b",
    },
  ];

  // ===================== API DATA =====================
  const [courseData, setCourseData] = useState([]);

  function GetCourseDetails() {
    const url = `${config.url.FAC_URL}getCourseIntakeList`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true && res?.data?.list?.length > 0) {
          setCourseData(res.data.list);
        } else {
          setCourseData([]);
        }
      })
      .catch((err) => {
        console.error("API Fetch Error:", err);
      });
  }

  useEffect(() => {
    GetCourseDetails();
    checkNewProgramData();
  }, []);

  const filteredCardData =
    serviceTitle === "New Program"
      ? cardData.filter(
        (card) =>
          card.id === "admission" ||
          card.id === "new" ||
          card.id === "Final"
      )
      : (serviceTitle === "New Additional Section" || serviceTitle === "Additional Section")
        ? cardData.filter(
          (card) =>
            card.id === "admission" ||
            card.id === "additional"
        )
        : serviceTitle === "Conversion of Program"
          ? cardData.filter(
            (card) =>
              card.id === "admission" ||
              card.id === "conversion"
          )
          : cardData;
  // ===================== RENDER =====================
  return (
    <jnb.Container fluid className="py-4 bg-white rounded shadow-sm">
      <h5 className="mb-3 innerheader-new">
        <span> Nature of Proposed Changes</span>
      </h5>

      {/* Info banner – shows lock status */}
      {!firstTabSubmitted && (
        <jnb.Alert variant="warning" className="mb-4 py-2">
          <FaLock className="me-2" />
          <strong>First, complete the "Admission Details & Result Analysis" section.</strong> All
          other tabs will be unlocked automatically after you submit it.
        </jnb.Alert>
      )}
      {/* {firstTabSubmitted && (
        <jnb.Alert variant="success" className="mb-4 py-2">
          ✅ All tabs are now unlocked. You can switch freely.
        </jnb.Alert>
      )} */}

      {/* Selector Grid */}
      <jnb.Row className="g-2 justify-content-center">
        {/* {cardData.map((card) => { */}
        {filteredCardData.map((card) => {
          const isActive = activeTab === card.id;
          // Disable if not the first tab and firstTabSubmitted is false
          const isDisabled = !firstTabSubmitted && card.id !== "admission";

          return (
            <jnb.Col key={card.id} xs={6} sm={4} md={3} lg={2}>
              <div
                onClick={() => handleToggle(card.id)}
                role="button"
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    handleToggle(card.id);
                  }
                }}
                className={`modern-selector ${isActive ? "active" : ""} ${isDisabled ? "disabled" : ""
                  }`}
              >
                <div
                  className="icon-container"
                  style={{ color: isActive ? "#ffc107" : card.color }}
                >
                  {card.icon}
                  {isDisabled && (
                    <FaLock className="ms-1" size={12} style={{ color: "#dc3545" }} />
                  )}
                </div>
                <div className="text-container">
                  <span className="selector-title">{card.title}</span>
                  {isDisabled && (
                    <span className="badge bg-danger ms-1" style={{ fontSize: "8px" }}>
                      locked
                    </span>
                  )}
                </div>
              </div>
            </jnb.Col>
          );
        })}
      </jnb.Row>

      {/* Dynamic Content */}
      <div className="mt-4 pt-3">
        {activeTab === "new" && (
          <div key="new" className="animate-slide-up">
            <NewCourse typee={activeTab} courseData={courseData} />
          </div>
        )}

        {/* {activeTab === "closure" && (
          <div key="closure" className="animate-slide-up">
            <NewClosureAdditional typee={activeTab} courseData={courseData} />
          </div>
        )} */}

        {activeTab === "additional" && (
          <div key="additional" className="animate-slide-up">
            <NewAdditonalSection typee={activeTab} courseData={courseData} />
          </div>
        )}

        {activeTab === "conversion" && (
          <div key="conversion" className="animate-slide-up">
            <NewConversionProgramForDg type={activeTab} courseData={courseData} />
          </div>
        )}

        {activeTab === "Final" && (
          <div key="Final" className="animate-slide-up">
            {hasNewProgramData ? (
              <FinalAmountForIntakeTabs />
            ) : (
              <jnb.Alert variant="warning" className="mt-3">
                <jnb.Alert.Heading>No New Programs Found</jnb.Alert.Heading>
                <p>
                  Please add at least one new program in the <strong>"New Program"</strong> tab
                  before accessing the Final Confirmation.
                </p>
              </jnb.Alert>
            )}
          </div>
        )}
        {activeTab === "admission" && (
          <div key="admission" className="animate-slide-up">
            <AdmissionAndResultAnalysis
              type={activeTab}
              courseData={courseData}
              onFirstTabSubmit={handleFirstTabSubmit}
            />
          </div>
        )}
      </div>

      <style>{`
        .modern-selector {
          background: #ffffff;
          border: 1px solid #e9ecef;
          border-radius: 8px;
          padding: 12px 8px;
          text-align: center;
          cursor: pointer;
          transition: all 0.2s ease-in-out;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          height: 100%;
          min-height: 85px;
        }

        .modern-selector:hover {
          border-color: #dee2e6;
          background: #fdfdfd;
          transform: translateY(-2px);
        }

        .modern-selector.active {
          background: #444444;
          border-color: #444444;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
        }

        /* Disabled (locked) style */
        .modern-selector.disabled {
          opacity: 0.65;
          cursor: not-allowed;
          background: #f8f9fa;
          border-color: #dee2e6;
        }

        .modern-selector.disabled:hover {
          transform: none;
          background: #f8f9fa;
        }

        .icon-container {
          font-size: 20px;
          margin-bottom: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;
        }

        .selector-title {
          font-size: 11px;
          font-weight: 600;
          color: #495057;
          line-height: 1.2;
        }

        .modern-selector.active .selector-title {
          color: #ffffff;
        }

        .badge.bg-danger {
          font-size: 8px;
          padding: 2px 4px;
          vertical-align: middle;
        }

        .animate-slide-up {
          animation: slideUp 0.3s ease-out forwards;
        }

        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </jnb.Container>
  );
}